/**
 * Created by moshemal on 5/26/16.
 */
module.exports = window.Ember;